export default "__VITE_ASSET__af4281c8__"